var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconModem128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.488 83.2959H19.5581C16.4885 83.2959 14 85.6381 14 88.5271V101.605C14 104.494 16.4885 106.836 19.5581 106.836H108.488C111.558 106.836 114.046 104.494 114.046 101.605V88.5271C114.046 85.6381 111.558 83.2959 108.488 83.2959Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3682 39.1582V83.2962",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3682 95.0674H49.3106",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4482 95.0674H96.3907",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7354 95.0674H81.6778",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1023 42.4871C51.1652 42.4871 54.4588 39.1936 54.4588 35.1307C54.4588 31.068 51.1652 27.7744 47.1023 27.7744C43.0397 27.7744 39.7461 31.068 39.7461 35.1307C39.7461 39.1936 43.0397 42.4871 47.1023 42.4871Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7623 27.3867C29.0041 29.9761 27.9766 33.1017 27.9766 36.4674C27.9766 39.7842 28.9743 42.8681 30.686 45.435",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2428 21.5029C17.6901 25.4235 16.207 30.1043 16.207 35.1314C16.207 40.1735 17.6989 44.8669 20.2653 48.7945",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3652 26.4385C65.1237 29.0278 66.1512 32.1537 66.1512 35.5194C66.1512 38.8362 65.1535 41.9199 63.4416 44.4867",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8848 21.8906C76.4373 25.8112 77.9206 30.492 77.9206 35.5191C77.9206 40.5612 76.4287 45.2546 73.8623 49.1822",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconModem128);
export default __webpack_public_path__ + "static/media/pictogramBeaconModem128.3ff1e10b314f6ca1630252fe1de6885d.svg";
export { ForwardRef as ReactComponent };